export default "__VITE_ASSET__6f6f2801__"